<template>
    <section>
        <div class="container mt-5">
            <div class="img-promotion">
                <div class="content p-3">
                    <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/promotions/lineman-promotion.png" alt="lineman promotion" class="responsive">
                </div>
            </div>
            <div class="text-center mt-3 code-promotion">
              <div class="block-code">
                <p class="d-flex align-items-center" style="margin-bottom: 0px;"><strong ref="textCode" class="text-code">BNLINEMAN</strong>&nbsp;
                    <template v-if="copied === false">
                        <button class="btn btn-copy" @click="copy('BNLINEMAN')"><img src="/static/img/copy-svgrepo-com.svg" class="filter" alt="คัดลอก" width="30"></button>
                    </template>
                    <template v-else>
                        <button class="btn"><img src="/static/img/check-circle-svgrepo-com-trans.svg" alt="" width="30"></button>
                    </template>
                </p>
              </div>
                <p class="mt-2"><strong>(จำกัด 1 User / 1 สิทธิ์)</strong></p>
            </div>
            <div class="text-center mt-5 mb-4">
                <p>ดาวน์โหลดแอปได้ที่</p>
                <a href="https://apple.co/3LdSWNi" target="_blank"><img height="38" alt="Line BeNeat" src="/static/img/btn-app-store.svg"></a>
                <a href="https://bit.ly/3zAwDio" target="_blank"><img height="38" alt="Line BeNeat" src="/static/img/btn-play-store.svg"></a>
            </div>
        </div>
    </section>
</template>
<script>
export default {
  data () {
    return {
      text: 'BNLINEMAN',
      copied: false
    }
  },
  methods: {
    copy (text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      //   let success = window.navigator.clipboard.writeText(storage.value)
      try {
        const successful = document.execCommand('copy')
        // console.log('success', successful)
        document.execCommand('copy')
        document.body.removeChild(el)
        if (successful) {
          this.copied = true
          setTimeout(() => {
            this.copied = false
          }, 3000)
        }
      } catch (err) {
        console.log('DEBUG', 'Oops, unable to copy')
        document.body.removeChild(el)
      }
    }
  }
}
</script>
<style scoped>
.responsive {
  width: 100%;
  height: auto;
}
button.btn {
  padding: 0 !important;
}
.text-code {
  font-size: 25px;
}
.code-promotion .block-code {
  display: inline-block;
  padding: 10px;
  justify-content: center;
  border: 1px dashed;
  .text-code {
    align-content: center;
  }
}
img.filter {
  filter: invert(49%) sepia(68%) saturate(2131%) hue-rotate(159deg) brightness(92%) contrast(101%);
}
</style>


// WEBPACK FOOTER //
// src/components/landingPage/LinemanPromotion.vue